<template>
  <div class="OAuthReturn">
    OAuthReturn
    <div>{{ error }}</div>
  </div>
</template>
<script>
import QS from 'query-string';
import bokalSourage from 'services/bokalSourage';
import { AUTH_RETURN_URLS } from 'const';

export default {
  name: 'AdsAccOAuthReturnPage',

  data: () => ({ error: '' }),

  mounted () {
    // AdsAccs.vue uses state as a key for saving previous url
    // State remains unchanged through authorization process
    const { state } = QS.parse(window.location.search);

    const returnUrls = bokalSourage.get(AUTH_RETURN_URLS) || {};
    const saved = returnUrls[state];
    if (!saved) {
      console.log(state, returnUrls);
      this.error = 'saved url not found';
      return;
      // throw new Error('AdsAccOAuthReturnPage: saved url not found');
    }

    delete returnUrls[state];
    bokalSourage.set(AUTH_RETURN_URLS, returnUrls);


    this.$router.push(`${ saved.url }${ window.location.search }&type=${ saved.accType }`);
  },
};
</script>
